<template>
    <div class="modal" :class="{'is-active':isActiveHtmlModal}">
        <div @click="$emit('closeHtmlModal')" class="modal-background"></div>
        <div class="modal-content" style="width: 60%;height: 70%">
            <div class="modal-header">
            <div class="header-content">
                <div class="header-left">
                <h2 class="modal-title">{{headerFlightText}} - RAIM Prediction Report</h2>
                </div>
                <button class="close-btn" @click="$emit('closeHtmlModal')" >
                <font-awesome-icon icon="times" />
                </button>
            </div>
        </div>
            <section class="modal-card-body">
                <div v-html="GetraimPredictionHtml"></div>
            </section>
               <footer class="modal-card-foot">
            </footer>

        </div>
    </div>
</template>

<script>
    export default {
        name: "HtmlRendering",
        data() {
            return {
                raimPredictionHtml : ""
            }
        },
        props: ['isActiveHtmlModal', 'WRJsonData' , 'headerFlightText'],
        created() {
            if (this.WRJsonData !=null)
            {
                this.raimPredictionHtml = this.WRJsonData.RaimPredictionHTMLText ;
            }
            else
            {
                this.raimPredictionHtml = "<p>Raim Prediction data not found.</p>" ;
            }
        },
        computed: {

            GetraimPredictionHtml : function() {

                if (this.WRJsonData !=null)
                {
                    return  this.WRJsonData.RaimPredictionHTMLText ;
                }
                else
                {
                    return "<p>Raim Prediction data not found.</p>" ;
                }


            }

        },
        mounted() {
            document.body.addEventListener('keyup', e => {
                if (e.keyCode === 27)
                { //ESC
                    this.$emit('closeHtmlModal');
                }
            })
        },
        methods: {}
    }
</script>

<style scoped>


</style>
